interface Props {
  error: string;
}
export const ErrorMessage = ({error}: Props) => {
  return <> {error !='' && <div className={'text-danger my-1'}>{error}</div>}</>
}
